import React, { useMemo } from "react";

import { AssetClassId } from "@fartherfinance/frontend/api/Investment/types";

import { usePortfolioBuilderContext } from "../../PortfolioBuilder/reducer/Context";
import {
  AssetClassCategory,
  Children,
  ElementID,
} from "../../PortfolioBuilder/reducer/Types";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import ParentRow from "./ParentRow";

import styles from "./TableRow.module.css";

interface Props {
  id: ElementID;
  name: string;
  assetClassCategory: AssetClassCategory;
  assetClassId: AssetClassId;
  weight: string;
  isLocked: boolean;
  expand: boolean;
  isInvisible: boolean;
  elementChildren: Children;
}

const AssetClassRow: React.FC<Props> = ({
  id,
  name,
  assetClassCategory,
  assetClassId,
  weight,
  isLocked,
  expand,
  isInvisible,
  elementChildren,
}) => {
  const { state } = usePortfolioBuilderContext();

  const hasOnlyBottomBorder = useMemo(
    () =>
      isInvisible && state.modelTable.length > 1 && elementChildren.length > 0,
    [isInvisible, state.modelTable, elementChildren]
  );

  return (
    <div
      className={toClassName(styles.assetClassContainer, {
        [styles.invisibleAssetClass]: isInvisible && !hasOnlyBottomBorder,
        [styles.onlyBottomBorder]: hasOnlyBottomBorder,
      })}
    >
      <ParentRow
        id={id}
        type={"AssetClass"}
        name={name}
        assetClassCategory={assetClassCategory}
        assetClassId={assetClassId}
        weight={weight}
        isLocked={isLocked}
        elementChildren={elementChildren}
        level={isInvisible ? -1 : 0}
        isInvisible={isInvisible}
        isInInvisibleAssetClass={isInvisible}
        expand={expand}
        isInSleeve={false}
      />
    </div>
  );
};

export default AssetClassRow;
